import './logo-section-style.scss'

import React from 'react'
import styled from 'styled-components'

import { withTrans } from '@/i18n/withTrans'
import { mobileFirstDevice } from '@/utils/media-queries'

import logo2 from './logo2.png'
import logo4 from './logo4.png'

const ImageWrapper = styled('img')`
  @media ${mobileFirstDevice.mini} {
    max-width: 290px;
    max-height: 70px;
    margin-top: 24px;
  }
  @media ${mobileFirstDevice.mobile} {
    max-width: 290px;
    max-height: 70px;
    margin-top: 24px;
  }
  @media ${mobileFirstDevice.tablet} {
    height: 60px;
    max-width: unset;
    margin-right: 38px;
    margin-top: 0px;
  }
  @media ${mobileFirstDevice.laptop} {
    height: 96px;
    max-width: unset;
    margin-right: 59px;
  }
`

const Logo4Wrapper = styled(ImageWrapper)`
  @media ${mobileFirstDevice.mobile} {
    height: 82px;
    max-height: 90px;
  }
  @media ${mobileFirstDevice.laptop} {
    height: 90px;
  }
`

const LogoContainer = styled('div')`
  border-top: 1px solid #cacaca;
  border-bottom: 1px solid #cacaca;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  /* img{
    object-fit: scale-down;
  } */
  @media ${mobileFirstDevice.mini} {
    margin-bottom: 80px;
    padding: 0px 21.5px 24px;
    justify-content: space-between;
  }
  @media ${mobileFirstDevice.mobile} {
    margin-bottom: 80px;
    padding: 0px 21.5px 24px;
    justify-content: space-between;
  }
  @media ${mobileFirstDevice.tablet} {
    margin-bottom: 0;
    padding: 42px 0px;
    justify-content: start;
  }
  @media ${mobileFirstDevice.laptop} {
    margin-bottom: 61px;
    padding: 50px 0px 58px;
    justify-content: start;
  }
`

const LogoSection = () => (
  <section>
    <LogoContainer>
      <ImageWrapper src={logo2} />
      <Logo4Wrapper src={logo4} />
    </LogoContainer>
  </section>
)

export default withTrans(LogoSection)
